module.exports = __webpack_public_path__ + "img/loading_white.3471a239.png";